<template>
  <div class="trust">
    <TrustUs />
  </div>
</template>

<script lang="ts" setup>
import TrustUs from '@/features/TrustUs.vue';
</script>

<style lang="scss" scoped>
.trust {
  display: flex;
  justify-content: center;
  padding-top: var(--alias-space-80);

  @include adaptivity.tablet {
    padding-top: var(--alias-space-64);
  }

  @include adaptivity.mobile {
    padding-top: var(--alias-space-48);
  }
}
</style>
